import styled from '@emotion/styled';
import elevate from 'storybookConfig/mixins/elevate';
import Button from 'storybookConfig/stories/molecules/Button';

interface DecisionButtonProps {
  isActive: boolean;
  $padding?: string;
}

const DecisionButton = styled(Button, {
  shouldForwardProp: (prop) => !['isActive', '$padding'].includes(prop),
})<DecisionButtonProps>`
  all: unset;
  padding: ${({ $padding = '24px' }) => $padding};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.color.info100 : theme.color.white};
  border: 1px solid
    ${({ theme, isActive }) => (isActive ? theme.color.blue300 : theme.color.gray200)};
  border-radius: 8px;

  ${({ isActive }) => isActive && elevate('1')};
`;

export default DecisionButton;
